import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function saveSubscribePortPush(params) {
  return request({
    url: URL.sys.saveSubscribePortPush,
    method: 'post',
    params
  })
}

export function remove(data) {
  return request({
    url: URL.sys.removeSubscribePortPush,
    method: 'post',
    data
  })
}
